import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"

// Meta Pixel Tracking
//
// @example:
//   <button data-controller="fbq"
//           data-action="fbq#track"
//           data-fbq-event-name-value="click"
//   >Click Me</button>
export default class extends Controller {

  static values = {
    eventName: String,
    eventParams: Object
  }

  connect() {
    Loggable(this, { debug: true })
    this.log("connected")
  }

  track() {
    if (typeof fbq === "undefined") {
      return
    }
    this.log("track", this.eventNameValue)
    fbq("track", this.eventNameValue)
  }

}
